import lightTheme from "./lightTheme";
import darkTheme from "./darkTheme";

const themes = {
  lightTheme,
  darkTheme,
};

export function getCurrentTheme(theme) {
  if (theme && theme === "light") {
    return themes["lightTheme"];
  }
  return themes["darkTheme"];
}

export default themes;
